// extracted by mini-css-extract-plugin
export default {"element":"RotateScreen_element__5fZ9t","isDarkMode":"RotateScreen_isDarkMode__J96t3","heading":"RotateScreen_heading__U6eLz"};